module.exports = __webpack_public_path__ + "static/palettte2-dddd0f7a7d978d0e9aef558ce2aa2d9c.jpg";